  <div *ngIf="show_feed_post_modal==true" [config]="{ show: true, backdrop: 'static' }" (onHidden)="onHidden()" bsModal
    #autoShownModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <!--*********************End Post ******************* -->
    <!-- create post -->

    <app-create-post *ngIf="post_screen==0" [callingFrom]="sourceScreenName"  (nextPostScreen)="nextPostScreen($event)"></app-create-post>

    <!-- tag connection -->

    <app-tag-connection *ngIf="post_screen==1"  [callingFrom]="sourceScreenName" (nextPostScreen)="nextPostScreen($event)"></app-tag-connection>

    <!-- post type -->

    <app-post-type *ngIf="post_screen==2"  [callingFrom]="sourceScreenName" (nextPostScreen)="nextPostScreen($event)"></app-post-type>

    <!-- draft  -->

    <app-post-draft *ngIf="post_screen==3" [callingFrom]="sourceScreenName" (nextPostScreen)="nextPostScreen($event)"></app-post-draft>

    <!-- post association -->
    <app-post-association *ngIf="post_screen==4" [callingFrom]="sourceScreenName" (nextPostScreen)="nextPostScreen($event)"></app-post-association>

    <!-- Post topic filter on community -->
    <app-filter-topic *ngIf="post_screen==5"  [callingFrom]="sourceScreenName" (nextPostScreen)="nextPostScreen($event)"></app-filter-topic>

    <!--  -->
    <div *ngIf="post_screen==5 || post_screen==5.1" class="custom-theme-modal modal-dialog modal-md modal-dialog-centered discard-popup" role="document">
      <!-- new design -->

      <div class="modal-content">
        <div class="modal-header pt-4">
          <div class="row">
            <div class="col-12">
              <h6 class="heading-4">
                {{mls.languageText.create_post_save_modal.key1}}
                <span *ngIf="mls?.is_lskey_display==1">(create_post_save_modal.key1)</span>
                <span class="cursor-pointer text-right float-right" (click)="cancelClose()">
                  <img src="assets/themes/icons/cancel.svg" alt="cross">
                </span>
              </h6>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <button (click)="continueEditPost()"
            class="btn-design filled medium w-100 mb-4">
            {{mls.languageText.create_post_save_modal.key4}}<span
            *ngIf="mls?.is_lskey_display==1">(create_post_save_modal.key4)</span>
          </button>
          <button *ngIf="(dss.isRepostStatus !== repostStatus.TWO) && !(dss.nextButtonEnabled &&  dss.topic_community_flag == 1 && dss.calling_from_community)" 
            (click)="saveAsDraft()"
            class="btn-design outline medium w-100 mb-2">
                {{mls.languageText.create_post_save_modal.key2}}
            <span *ngIf="mls?.is_lskey_display==1">(create_post_save_modal.key2)</span>
          </button>

          <button (click)="discardPost()"
            class="btn-design outline medium w-100">
            {{mls.languageText.create_post_save_modal.key3}}<span
              *ngIf="mls?.is_lskey_display==1">(create_post_save_modal.key3)</span>
          </button>
        </div>
      </div>
    </div>
  </div>
